// Sticky header: transparent hairline at the top of the page, a real one once
// the page has scrolled under it (the CSS handles the blur/tint).
const header = document.querySelector("[data-header]")
if (header) {
  const update = () => header.classList.toggle("is-scrolled", window.scrollY > 8)
  update()
  window.addEventListener("scroll", update, { passive: true })
}

// Use-cases dropdown: click to toggle, closes on outside click and Escape.
const uc = document.querySelector("[data-usecases]")
if (uc) {
  const trigger = uc.querySelector("[data-usecases-trigger]")
  const menu = uc.querySelector("[data-usecases-menu]")
  const chevron = uc.querySelector("[data-usecases-chevron]")
  const setOpen = (open) => {
    menu.hidden = !open
    trigger.setAttribute("aria-expanded", String(open))
    if (chevron) chevron.style.transform = open ? "rotate(180deg)" : ""
  }
  trigger.addEventListener("click", (e) => {
    e.stopPropagation()
    setOpen(menu.hidden)
  })
  document.addEventListener("click", (e) => {
    if (!menu.hidden && !uc.contains(e.target)) setOpen(false)
  })
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !menu.hidden) {
      setOpen(false)
      trigger.focus()
    }
  })
}
